import { render, staticRenderFns } from "./Lgx243090067378143232.vue?vue&type=template&id=124fa038&scoped=true&"
import script from "./Lgx243090067378143232.vue?vue&type=script&lang=js&"
export * from "./Lgx243090067378143232.vue?vue&type=script&lang=js&"
import style0 from "./Lgx243090067378143232.vue?vue&type=style&index=0&id=124fa038&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "124fa038",
  null
  
)

export default component.exports